// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomSwitch_CustomSwitch__Ga6Q3 {
  flex: 1 1;
  width: 100%;
}
.CustomSwitch_CustomSwitch__Ga6Q3 .CustomSwitch_field__D97os {
  min-width: 50%;
  flex: 1 1;
  height: 100%;
}
.CustomSwitch_CustomSwitch__Ga6Q3 .CustomSwitch_field__D97os label {
  width: 168px;
  white-space: nowrap;
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}
.CustomSwitch_CustomSwitch__Ga6Q3 .CustomSwitch_switchWrapper__ASx8g {
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
}
.CustomSwitch_CustomSwitch__Ga6Q3 .CustomSwitch_switchWrapper__ASx8g button {
  margin-right: 8px;
}

.CustomSwitch_CustomSelect__FzgZu {
  flex: 1 1;
}
.CustomSwitch_CustomSelect__FzgZu .CustomSwitch_select__j9Dd3 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/common/components/CustomSwitch/CustomSwitch.module.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,WAAA;AACF;AAAE;EACE,cAAA;EACA,SAAA;EACA,YAAA;AAEJ;AAAI;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;AAEN;AAEE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAAJ;AAEI;EACE,iBAAA;AAAN;;AAKA;EACE,SAAA;AAFF;AAGE;EACE,WAAA;AADJ","sourcesContent":[".CustomSwitch {\n  flex: 1 1;\n  width: 100%;\n  .field {\n    min-width: 50%;\n    flex: 1 1;\n    height: 100%;\n\n    label {\n      width: 168px;\n      white-space: nowrap;\n      overflow: hidden;\n      display: inline-block;\n      text-overflow: ellipsis;\n    }\n  }\n\n  .switchWrapper {\n    text-align: right;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 4px;\n\n    button {\n      margin-right: 8px;\n    }\n  }\n}\n\n.CustomSelect {\n  flex: 1 1;\n  .select {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CustomSwitch": `CustomSwitch_CustomSwitch__Ga6Q3`,
	"field": `CustomSwitch_field__D97os`,
	"switchWrapper": `CustomSwitch_switchWrapper__ASx8g`,
	"CustomSelect": `CustomSwitch_CustomSelect__FzgZu`,
	"select": `CustomSwitch_select__j9Dd3`
};
export default ___CSS_LOADER_EXPORT___;
